import { render, staticRenderFns } from "./bindChannel.vue?vue&type=template&id=eae70484&scoped=true"
import script from "./bindChannel.vue?vue&type=script&lang=js"
export * from "./bindChannel.vue?vue&type=script&lang=js"
import style0 from "./bindChannel.vue?vue&type=style&index=0&id=eae70484&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae70484",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eae70484')) {
      api.createRecord('eae70484', component.options)
    } else {
      api.reload('eae70484', component.options)
    }
    module.hot.accept("./bindChannel.vue?vue&type=template&id=eae70484&scoped=true", function () {
      api.rerender('eae70484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/shoplist/bindChannel.vue"
export default component.exports